import { render } from "./CreateServiceRequisition.vue?vue&type=template&id=3c764c2c&scoped=true"
import script from "./CreateServiceRequisition.vue?vue&type=script&lang=js"
export * from "./CreateServiceRequisition.vue?vue&type=script&lang=js"

import "./CreateServiceRequisition.vue?vue&type=style&index=0&id=3c764c2c&scoped=true&lang=css"

import exportComponent from "/var/www/vhosts/jahajibd.com/ia.jahajibd.com/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c764c2c"]])

export default __exports__